// RadioGroup.js
import React from "react";
import { Field, ErrorMessage } from "formik";
import styles from "./RadioGroup.module.scss";
import ErrorText from "components/shared/errortext/ErrorText";

const RadioGroup = (props) => {
  const { label, name, options, isRequired, fontSize = false, ...rest } = props;

  return (
    <div className={styles.radioGroup}>
      <label className={styles.label} style={{ fontSize: fontSize ? "16px" : "" }}>
        {label} {isRequired && <span className={styles.requiredMark}>*</span>}
      </label>
      <div className={styles.radioOptions}>
        <Field name={name}>
          {({ field }) =>
            options.map((option) => (
              <label key={option.value} className={styles.radioOption}>
                <input
                  type="radio"
                  {...field}
                  {...rest}
                  value={option.value}
                  checked={field.value === option.value}
                />
                {option.key}
              </label>
            ))
          }
        </Field>
      </div>
      <ErrorMessage name={name} component={ErrorText} />
    </div>
  );
};

export default RadioGroup;
